import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import getUserToken from '../helpers/tokenValidation';
import { alertActions } from './auth/alertSlice';

const backendURL = process.env.REACT_APP_API_URL;

export const uploadingUserDetails = createAsyncThunk(
  'userDetails/upload',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`,
        },
      };

      const { data } = await axios.post(
        `${backendURL}/api/userDetails`,
        arg,
        config
      );

      dispatch(
        alertActions.createAlert({
          message: 'SuccessFully Created',
          type: 'success',
        })
      );

      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        dispatch(
          alertActions.createAlert({
            message: error.response ? error.response.data.message : error.message,
            type: 'warning',
          })
        );
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateUserDetails = createAsyncThunk(
  'userDetails/update',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`,
        },
      };

      const { data } = await axios.put(
        `${backendURL}/api/updateUserDetails`,
        arg,
        config
      );

      dispatch(
        alertActions.createAlert({
          message: 'Successfully Updated',
          type: 'success',
        })
      );

      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        dispatch(
          alertActions.createAlert({
            message: error.response ? error.response.data.message : error.message,
            type: 'warning',
          })
        );
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
